import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import CreateWarehouseGoodsReceiptContainer from 'app/containers/InventoryManagement/WarehousePurchaseGoodsReceipt'

const CreateWarehouseGoodsReceiptContainerPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.inventory_management)}</PageTitle>
      <CreateWarehouseGoodsReceiptContainer />
    </>
  )
}
const CreateWarehouseGoodsReceiptContainerPage = memo(
  CreateWarehouseGoodsReceiptContainerPageCpn,
  isEqual,
)

export default CreateWarehouseGoodsReceiptContainerPage
